import { useEffect, useState } from 'react';
import api from '~/libs/api';
import { AxiosResponse } from 'axios';
import { errorMessages } from '~/constants/errorMessages.ts';
import { TFormAddress } from '~/modules/identification/types';

export const useGetAddressInfo = (values?: TFormAddress, isModalOpened?: boolean) => {
  const [cities, setCities] = useState([]);
  const [streets, setStreets] = useState([]);
  const [error, setError] = useState<string | null>(null);

  const cleanError = () => setError(null);

  useEffect(() => {
    const makeRequest = !!values?.city?.value && values?.city?.value !== '-1' && isModalOpened;

    if (!makeRequest) return;
    api
      .get(`/dictionary-service/city/${values?.city?.value}/street`)
      .then((response: AxiosResponse) => {
        setStreets(
          response.data?.map((street: { fullName: string; id: string }) => ({
            label: street.fullName,
            value: street.id.toString(),
          }))
        );
        setError(null);
      })
      .catch(() => setError(errorMessages.SERVICE_UNAVAILABLE));
  }, [values?.city?.value, isModalOpened]);

  useEffect(() => {
    const cityFilled =
      !!values?.region?.value &&
      !!values?.district?.value &&
      ![values?.region?.value, values?.district?.value].includes('-1') &&
      isModalOpened;

    if (!cityFilled) return;

    api
      .get(`/dictionary-service/region/${values?.region?.value}/city`)
      .then((response: AxiosResponse) => {
        setCities(
          response.data?.map((city: { fullName: string; id: string }) => ({
            label: city.fullName,
            value: city.id.toString(),
          }))
        );
        setError(null);
      })
      .catch(() => setError(errorMessages.SERVICE_UNAVAILABLE));
  }, [values?.region?.value, values?.district?.value, isModalOpened]);

  return [cities, streets, error, cleanError];
};
